"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComponentFormLink = exports.ComponentFormWarning = exports.Warning = exports.ContextSubMenu = exports.ResizeHandle = exports.ToolbarButtonLabel = exports.HorizontalToolbarButton = exports.ToolbarButton = exports.ToolbarIcon = exports.SubmitButton = exports.ComponentFormError = exports.ComponentFormSubmitButton = exports.ComponentFormCloseButton = exports.ComponentFormUnwrapButton = exports.ComponentFormButton = exports.ComponentFormOption = exports.ComponentFormSelect = exports.ComponentFormCheckBox = exports.ComponentFormRadio = exports.ComponentFormRadioGroup = exports.ComponentFormTextArea = exports.ComponentFormText = exports.ComponentFormLabel = exports.ComponentFormList = exports.ComponentFormListItem = exports.ComponentFormDescription = exports.ComponentFormFieldTitle = exports.ComponentFormFieldWrapper = exports.ComponentFormTitle = exports.Icon = exports.Anchor = exports.Option = exports.Select = exports.CheckBox = exports.Radio = exports.RadioGroup = exports.TextArea = exports.Text = exports.Form = exports.Hr = exports.Button = exports.Span = exports.Div = exports.Input = exports.Img = exports.Label = exports.Title = void 0;

var react_1 = __importDefault(require("react"));

var lodash_1 = require("lodash");

var informed_1 = require("informed");

var fclasses_1 = require("@bodiless/fclasses");

var core_1 = require("@bodiless/core");

require("./bodiless.index.css");

require("rc-tooltip/assets/bootstrap.css");

exports.Title = fclasses_1.stylable('h3');
exports.Label = fclasses_1.stylable('label');
exports.Img = fclasses_1.stylable('img');
exports.Input = fclasses_1.stylable('input');
exports.Div = fclasses_1.stylable('div');
exports.Span = fclasses_1.stylable('span');
exports.Button = fclasses_1.stylable('button');
exports.Hr = fclasses_1.stylable('hr');
exports.Form = fclasses_1.stylable('form');
exports.Text = fclasses_1.stylable(informed_1.Text);
exports.TextArea = fclasses_1.stylable(informed_1.TextArea);
exports.RadioGroup = fclasses_1.stylable(informed_1.RadioGroup);
exports.Radio = fclasses_1.stylable(informed_1.Radio);
exports.CheckBox = fclasses_1.stylable(informed_1.Checkbox);
exports.Select = fclasses_1.stylable(informed_1.Select);
exports.Option = fclasses_1.stylable(informed_1.Option);
exports.Anchor = fclasses_1.stylable('a');
exports.Icon = lodash_1.flow(fclasses_1.addClasses('bl-p-grid-1 material-icons'), fclasses_1.withoutProps(['isActive']), fclasses_1.flowIf(fclasses_1.hasProp('isActive'))(fclasses_1.addClasses('bl-bg-primary bl-rounded')), fclasses_1.addProps({
  'aria-hidden': true
}))(exports.Span);
exports.ComponentFormTitle = fclasses_1.addClasses('bl-text-lg bl-font-bold bl-text-grey-100 bl-block bl-mb-grid-2 bl-min-w-xl-grid-1')(exports.Title);
exports.ComponentFormFieldWrapper = fclasses_1.addClasses('bl-mb-grid-3 bl-w-full')(exports.Div);
exports.ComponentFormFieldTitle = fclasses_1.addClasses('bl-mb-grid-2 bl-font-bold bl-text-grey-100')(exports.Div);
exports.ComponentFormDescription = fclasses_1.addClasses('bl-text-xs bl-text-grey-100 bl-block bl-mb-grid-2 bl-max-w-xl-grid-1')(exports.Div);
exports.ComponentFormListItem = fclasses_1.addClasses('first:bl-border-t-0 bl-border-t bl-py-grid-1 bl-px-grid-1 bl-max-w-xl-grid-1')(fclasses_1.Li);
exports.ComponentFormList = fclasses_1.addClasses('list-none bl-max-h-xl-grid-1 bl-overflow-y-scroll')(fclasses_1.Ul);
exports.ComponentFormLabel = fclasses_1.addClasses('bl-text-xs bl-text-grey-100 bl-block')(exports.Label);
exports.ComponentFormText = fclasses_1.addClasses('bl-text-grey-900 bl-bg-grey-100 bl-text-xs bl-w-full bl-min-w-xl-grid-1 bl-block bl-my-grid-2 bl-p-grid-1')(exports.Text);
exports.ComponentFormTextArea = fclasses_1.addClasses('bl-resize bl-text-grey-900 bl-bg-grey-100 bl-text-xs bl-w-full bl-min-w-xl-grid-1 bl-min-h-grid-16 bl-block bl-my-grid-2 bl-p-grid-1')(exports.TextArea);
exports.ComponentFormRadioGroup = fclasses_1.addClasses('bl-mb-grid-2')(exports.RadioGroup);
exports.ComponentFormRadio = fclasses_1.addClasses('bl-mr-grid-2 bl-mb-grid-2 align-baseline')(exports.Radio);
exports.ComponentFormCheckBox = fclasses_1.addClasses('bl-mr-grid-2 bl-mb-grid-2 align-baseline')(exports.CheckBox);
exports.ComponentFormSelect = fclasses_1.addClasses("bl-text-grey-900 bl-bg-grey-100 bl-text-xs bl-w-full\n  bl-min-w-xl-grid-1 bl-block bl-my-grid-2 bl-p-grid-1")(exports.Select);
exports.ComponentFormOption = exports.Option;
exports.ComponentFormButton = fclasses_1.addClasses('bl-text-grey-200 bl-cursor-pointer hover:bl-text-green')(exports.Button);
exports.ComponentFormUnwrapButton = fclasses_1.addClasses('bl-absolute bl-bottom-0 bl-left-0 bl-mb-5 bl-ml-3 bl-cursor-pointer bl-underline')(exports.Button);
exports.ComponentFormCloseButton = lodash_1.flow(fclasses_1.addClasses('hover:bl-text-red bl-float-right'), fclasses_1.removeClasses('hover:bl-text-green'), core_1.withChild(function () {
  return react_1.default.createElement(exports.Icon, null, "cancel");
}))(exports.ComponentFormButton);

exports.ComponentFormSubmitButton = function (props) {
  return react_1.default.createElement("div", {
    className: "bl-clearfix"
  }, react_1.default.createElement(exports.ComponentFormButton, __assign({
    className: "bl-float-right"
  }, props), react_1.default.createElement(exports.Icon, null, "done")));
};

exports.ComponentFormError = fclasses_1.addClasses('bl-block bl-italic')(exports.Div);

exports.SubmitButton = function (props) {
  return react_1.default.createElement(exports.ComponentFormButton, __assign({
    type: "submit"
  }, props));
};

exports.ToolbarIcon = lodash_1.flow(fclasses_1.removeClasses('bl-p-grid-1'), fclasses_1.addClasses('bl-w-grid-8 bl-h-grid-8 md-36'))(exports.Icon);
exports.ToolbarButton = lodash_1.flow(fclasses_1.withoutProps(['isActive', 'isFirst', 'isDisabled']), fclasses_1.addClasses('bl-cursor-pointer bl-mb-3 bl-flex bl-flex-col bl-items-center'), fclasses_1.flowIf(fclasses_1.hasProp('isDisabled'))(lodash_1.flow(fclasses_1.addClasses('bl-text-grey-600'), fclasses_1.removeClasses('bl-text-grey-200'))), fclasses_1.addProps({
  type: 'button'
}))(exports.Button);
exports.HorizontalToolbarButton = lodash_1.flow(fclasses_1.removeClasses('bl-mb-3'), fclasses_1.addClasses('bl-mr-grid-2 last:bl-mr-grid-0'))(exports.ToolbarButton);
exports.ToolbarButtonLabel = fclasses_1.addClasses('bl-text-center bl-text-base')(exports.Span);
var ResizeHandleBar = fclasses_1.addClasses('bl-resizable-handle bl-border-solid bl-border-l-2 bl-border-primary bl-h-full')(exports.Div);
exports.ResizeHandle = lodash_1.flow(fclasses_1.addClasses('bl-flex bl-justify-center bl-w-5 bl-right-rem-1 bl-z-1 bl-h-three-quarters bl-relative bl-top-half bl-transform bl--translate-y-1/2'), core_1.withChild(function () {
  return react_1.default.createElement(ResizeHandleBar, null);
}))(exports.Div);
exports.ContextSubMenu = lodash_1.flow(fclasses_1.addClasses('bl-flex bl-text-white'), fclasses_1.addProps({
  role: 'toolbar',
  'aria-label': 'Submenu'
}))(exports.Div);
exports.Warning = lodash_1.flow(fclasses_1.addClasses('bl-w-grid-7 bl-text-yellow-500'))(function (props) {
  return react_1.default.createElement(exports.Icon, __assign({}, props), "report_problem_outlined");
});
exports.ComponentFormWarning = lodash_1.flow(fclasses_1.addClasses('bl-float-left bl-flex bl-items-center'))(function (_a) {
  var children = _a.children,
      rest = __rest(_a, ["children"]);

  return react_1.default.createElement(exports.Div, __assign({}, rest), react_1.default.createElement(exports.Warning, null), children);
});

var isDisabled = function isDisabled(props) {
  return fclasses_1.hasProp('disabled')(props);
};

exports.ComponentFormLink = lodash_1.flow(fclasses_1.addClasses('bl-cursor-pointer bl-text-xs bl-block bl-underline'), fclasses_1.addClassesIf(isDisabled)('bl-text-grey-600'), fclasses_1.removeClassesIf(isDisabled)('bl-cursor-pointer bl-text-grey-100 '))(exports.Anchor);